import * as actions from './actions';

export const initialState = {
  error: null,
  accessToken: '',
  profile: {},
  connectedSchool: { id: '', sid: '' },
  redirectToHome: false,
  accessibleSchoolIds: null,
  loading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SIGN_OUT_SUCCESS:
      return {
        ...state,
        accessToken: '',
      };
    case actions.SIGN_OUT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case actions.SET_AUTH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.SET_AUTH_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };
    case actions.SET_AUTH_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case actions.SET_ACCESSIBLE_SCHOOL_IDS:
      return {
        ...state,
        accessibleSchoolIds: action.payload.accessibleSchoolIds || [],
      };
    default:
      return state;
  }
};
